import { DocumentType, PassengerType, Title } from '../types/itinerary'

export type TravelClassType = 'Economy' | 'Business' | 'First'

export const travelersTypeTostringMap: Record<PassengerType, string> = {
    ADT: 'Adult',
    CHD: 'Child',
    INF: 'Infant'
}

export const travelersDocTypeOptionsMap: Record<DocumentType, string> = {
    //don't change the key and value of this object,
    //keys are the document types from the backend
    //values are the translation keys for the document types
    PASSPORT: 'passport',
    NATIONALID: 'nationalId',
    IQAMA: 'iqama'
}
// export const GENDERS = ['Male', 'Female', 'Other']
export const TITLES: Record<PassengerType, Title[]> = {
    ADT: ['Mr', 'Ms', 'Mrs'],
    CHD: ['Miss', 'Mstr'],
    INF: ['Miss', 'Mstr']
}
